package gr.tech.GRAttestation.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.base
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import gr.tech.GRAttestation.util.ROUTES
import org.jetbrains.compose.web.css.*


/*
    GENERAL PDF STYLE
*/
val GeneralParagraphStyle = CssStyle {
    base {
        Modifier
            .fontFamily("Times New Roman")
            .fontSize(13.3.px)
            .lineHeight(1.25)
    }
}

val PDFStatusTextStyle = CssStyle {
    base {
        Modifier
            .margin(0.px)
            .color(Colors.WhiteSmoke)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.5.cssRem)
    }
}

val PDFLoadingSpinnerAnimation = Keyframes {
    0.percent {
        Modifier
            .rotate(0.deg)
    }
    100.percent {
        Modifier
            .rotate(360.deg)
    }
}

val PDFColumnOverlay = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .padding(16.px)
    }
}

val PDFBackButtonStyle = CssStyle {
    base {
        Modifier
            .noBorder()
            .borderRadius(4.px)
            .padding(
                leftRight = 16.px,
                topBottom = 8.px
            )
            .backgroundColor(Theme.DarkGreen.rgb)
            .color(Colors.White)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.25.cssRem)
    }
}

val SmallerItemParagraphStyle = CssStyle {
    base {
        Modifier
            .fontFamily("Times New Roman")
            .fontSize(13.3.px)
            .lineHeight(1.12)
    }
}

val BoldUnderline = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Bold)
            .textDecorationLine(TextDecorationLine.Underline)
    }
}

val BoldItalic = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Bold)
            .fontStyle(FontStyle.Italic)
    }
}


/* INSERT FIELD STYLES */
val insertedFieldStyle = CssStyle.base {
    Modifier
        .position(Position.Absolute)
        .zIndex(2)
        //use top and left to move
}


/* PAGE BACKGROUNDS */
val backgroundStyle = CssStyle.base {
    Modifier
        .position(Position.Absolute)
        .top(0.px)
        .left(0.px)
        .width(100.percent)
        .height(100.percent)
        .objectFit(ObjectFit.Cover)
        .zIndex(1)
}

val pageStyle = CssStyle.base {
    Modifier
        .padding(topBottom = 54.px, leftRight = 94.px)
        .width(816.px) //exact width for format: a4
        .height(1056.px) //1344
        .position(Position.Relative)
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
        .overflow(Overflow.Hidden)
        .border(
            width = if (ROUTES.IS_DEV) 1.px else 0.px,
            style = if (ROUTES.IS_DEV) LineStyle.Solid else LineStyle.Hidden,
            color = if (ROUTES.IS_DEV) Colors.Black else Colors.Transparent
        )
}
